import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrganizationNotification } from './interface';
import { ApiService } from './../../Services/api.service';
import { StorageService } from './../../Services/storage.service';


export class Store<T>{
    private state$: BehaviorSubject<OrganizationNotification[]>;
    protected constructor(initialState: OrganizationNotification[] = []) {
        this.state$ = new BehaviorSubject(initialState);
    }
    getValue(): OrganizationNotification[] {
        return this.state$.getValue();
    }
    getState(): Observable<OrganizationNotification[]> {

        return this.state$.asObservable();
    }
    setState(item: OrganizationNotification[]): void {
        this.state$.next(item);
    }
}


@Injectable()
export class OrgNotificationStateManagement extends Store<OrganizationNotification>{
    constructor(
        private api: ApiService,
        private storage: StorageService
    ) {
        super();
    }

    update(newData: any): void {
        try {
            this.setState(newData);
            // const data = this.getValue();
        } catch (error) {
            console.log('Error ', error);
        }
    }

    get(): OrganizationNotification[] {
        let shifts: any = this.getValue();
        return shifts;
    }
    listen(): Observable<OrganizationNotification[]> {
        return this.getState();
    }
    addNotification(newItem: any): void {
        try {
            let data = this.getValue();
            const newData = (typeof newItem == 'string') ? JSON.parse(newItem) : newItem;
            // console.warn('newData', newData) //id mattum same ah varamah block pannnum
            if (data.filter((itm: any) => itm.id == newData.id).length > 0) {
                const returnData: any = data.map((item: any) => {
                    if (item && item['type'] == 'REQUEST' && item['id'] == newData.id) {
                        item.message = newData.message;
                    }
                    if (item && item['type'] == 'SOS' && item['id'] == newData.id) {
                        item.message = newData.message;
                    } if (item && item['type'] == 'Overspeed' && item['id'] == newData.id) {
                        item.message = newData.message;
                    }
                    return item;
                    // Old Codes
                    //       const currnentTMS = new Date().getTime();
                    //       const restrictedDays = new Date().setDate(new Date().getDate() - 2);
                    //       const restrictedDatetime = new Date(restrictedDays).setHours(0, 0, 0, 0);
                    //       const restrictedTimestamp = new Date(restrictedDatetime).getTime();
                    //       if (item.reg == newData.reg ) {
                    //         item.serverts = newData.serverts;
                    //         item.near = newData.near;
                    //         item.lat = newData.lat;
                    //         item.lng = newData.lng;
                    //         item.imei = newData.imei;
                    //         item.spd = newData.spd;
                    //         item.gpsts = newData.gpsts;
                    //         item.ac = newData.ac;
                    //       }
                    //      /*  if((restrictedTimestamp<= (item.gpsts.length>10? item.gpsts: item.gpsts *1000) )){
                    //       } */
                });
                    // console.log('Next triggered ', returnData);
                this.setState(returnData.filter(item => !!item));
            } else {
                data.push(newData);
                this.setState(data);
            }      // this.setState([...this.getValue(), newData]);

        } catch (error) {
            console.log('Error', error);
        }
    }

    //Remove
    removerNofit(id:any){
        try {
            let data = this.getValue();
            let filteredData = data.filter((item:any)=>item.id!=id)
            this.setState(filteredData)
        } catch (error) {
            console.log('Error', error);
        }
    }

    removeAllNotifications(){
        try {
            let filteredData = [];
            this.setState(filteredData)
        } catch (error) {
            console.log('Error', error);
        }
    }
    
}